var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlumbing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4221_1680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4221_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.79 7.66194L13.1171 4.98882L11.3463 6.74694L9.87191 5.28527L12.0898 3.05465C12.2351 2.90937 12.3972 2.80388 12.5761 2.73819C12.7551 2.6725 12.9355 2.63965 13.1171 2.63965C13.3073 2.63965 13.491 2.6725 13.6684 2.73819C13.8457 2.80388 14.0027 2.90937 14.1394 3.05465L15.6698 4.58507C15.8984 4.80507 16.0664 5.05666 16.1738 5.33986C16.2813 5.62291 16.335 5.91354 16.335 6.21173C16.335 6.46701 16.2907 6.71937 16.2019 6.96881C16.1133 7.21826 15.976 7.4493 15.79 7.66194ZM5.31254 11.319C5.10004 11.1064 4.99379 10.8593 4.99379 10.5778C4.99379 10.2962 5.10004 10.0492 5.31254 9.83652L7.21004 7.92632L8.68441 9.40069L6.76608 11.319C6.56205 11.5315 6.32191 11.6378 6.04566 11.6378C5.76955 11.6378 5.52518 11.5315 5.31254 11.319ZM4.08025 17.274C3.94344 17.1287 3.84004 16.9661 3.77004 16.7861C3.70004 16.6061 3.66504 16.4183 3.66504 16.2228C3.66504 16.0272 3.69796 15.8408 3.76379 15.6636C3.82948 15.4862 3.93497 15.3249 4.08025 15.1794L9.87191 9.40069L7.08171 6.59777C6.86921 6.39375 6.76428 6.15368 6.76691 5.87756C6.76955 5.60132 6.87719 5.35687 7.08983 5.14423C7.29386 4.93173 7.5374 4.8268 7.82046 4.82944C8.10365 4.83208 8.35157 4.93972 8.56421 5.15236L11.3463 7.93444L12.5338 6.74694L14.6507 8.88944C14.78 9.01875 14.8446 9.16382 14.8446 9.32465C14.8446 9.48534 14.78 9.63034 14.6507 9.75965C14.5214 9.88354 14.3723 9.94284 14.2036 9.93757C14.0348 9.93215 13.8698 9.85416 13.7084 9.70361L6.14587 17.2661C6.00059 17.4114 5.84059 17.5182 5.66587 17.5865C5.49129 17.655 5.31046 17.6892 5.12337 17.6892C4.93643 17.6892 4.75219 17.6542 4.57066 17.5842C4.389 17.5142 4.22553 17.4108 4.08025 17.274Z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/plumbing.3f796f8c.svg";
export { ForwardRef as ReactComponent };